export default "__VITE_ASSET__d825UHVZ__"